<template>
  <div class="post-rank">
    <div class="personal-week">
      <Title name="个人周发帖排行榜"/>
      <Loading class="loading-wrapper" v-if="personalShowLoading" size='20px'>加载中...</Loading>
      <template v-else>
        <div class="bs-post-wrapper">
          <div
            class="rank-item-container"
            v-if="personalData.length > 0"
          >
            <div class="personal-list">
              <RankItem
                v-for="(item, index) in personalData"
                :key="index"
                :rank="index+1"
                :avatar="item.headimgUrl"
                :nickname="item.nickName"
                :intro="item.about"
                :dataNumber="item.count"
              />
            </div>
            <Loading class="loading-end" v-if="personalEndLoading" size='20px'>加载中...</Loading>
            <div v-else class="loading-empty"></div>
          </div>
          <Empty v-else/>
        </div>
      </template>
    </div>
    <div class="team-week">
      <Title name="车队周发帖排行榜"/>
      <Loading class="loading-wrapper" v-if="teamShowLoading" size='20px'>加载中...</Loading>
      <template v-else>
        <template v-if="teamData.length > 0">
          <RankItem
            v-for="(item, index) in teamData"
            :key="index"
            :rank="index+1"
            :avatar="item.headimgUrl"
            :nickname="item.teamName"
            :intro="item.address"
            :dataNumber="item.count"
          />
        </template>
        <Empty v-else/>
      </template>
    </div>
    <div class="rank-end">榜单整点刷新</div>
  </div>
</template>

<script>
// 发帖排行榜
import Title from '../Title'
import RankItem from '../RankItem'
import Empty from '../Empty'
import { Toast, Loading } from 'vant'
import { getPersonalPost, getTeamPost } from '@/api/rank'
export default {
  name: 'RankPost',
  components: {
    Loading, Title, RankItem, Empty
  },
  props: [ 'bscroll' ],
  created () {
    this.getPersonalData(true)
    this.getTeamData(true)
  },
  beforeDestroy () {
    this.destroySCroll()
  },
  data () {
    return {
      personalData: [],
      teamData: [],
      personalShowLoading: false,
      personalLoading: false,
      teamShowLoading: false,
      teamLoading: false,
      personalEndLoading: false,
      reachBottom: false,
      personalPagination: {
        total: 0,
        page: 1,
        size: 10
      },
      childBS: null,
      parentBS: null
    }
  },
  methods: {
    initBScroll (dealay = 200, length) {
      const BScroll = this.bscroll
      const config = {
        scrollY: true,
        nestedScroll: true,
        click: true
      }
      setTimeout(() => {
        this.parentBS = new BScroll('.ranking-scroll', {
          ...config,
          bounce: {
            top: false,
            bottom: false
          }
        })
        if (length > 5) {
          this.childBS = new BScroll('.bs-post-wrapper', {
            ...config,
            pullUpLoad: true
          })
          this.childBS.on('pullingUp', this.pullingUpHandler)
          this.childBS.refresh()
        }
        this.parentBS.refresh()
      }, dealay)
    },
    pullingUpHandler () {
      this.onReachBottom()
    },
    destroySCroll () {
      this.parentBS && this.parentBS.destroy()
      this.childBS && this.childBS.destroy()
      this.parentBS = null
      this.childBS = null
    },
    // 获取个人周发帖排行
    getPersonalData (showLoading = false, page) {
      this.personalShowLoading = showLoading
      this.personalLoading = true
      page = page || this.personalPagination.page
      getPersonalPost({ page, size: this.personalPagination.size }).then(res => {
        // console.log(res.data)
        if (res.data.code === 0) {
          this.personalData = page === 1 ? res.data.data.items : this.personalData.concat(res.data.data.items)
          this.personalPagination.total = res.data.data.total
          this.personalShowLoading = false
          this.personalLoading = false
          this.personalEndLoading = false
        } else {
          throw new Error(res.data)
        }
        this.$nextTick(() => {
          if (page === 1) {
            this.initBScroll(500, this.personalData.length)
          } else {
            this.childBS && this.childBS.finishPullUp()
            this.childBS && this.childBS.refresh()
          }
        })
      }).catch(() => {
        Toast.fail('网络请求异常')
        this.personalShowLoading = false
        this.personalLoading = false
        this.personalEndLoading = false
      })
    },
    // 获取车队周发帖排行
    getTeamData (showLoading = false) {
      this.teamShowLoading = showLoading
      this.teamLoading = true
      getTeamPost({ page: 1, size: 3 }).then(res => {
        // console.log(res.data)
        if (res.data.code === 0) {
          this.teamData = res.data.data.items
          this.teamShowLoading = false
          this.teamLoading = false
        } else {
          throw new Error(res.data)
        }
      }).catch(() => {
        Toast.fail('网络请求异常')
        this.teamShowLoading = false
        this.teamLoading = false
      })
    },
    // scroll触底事件
    onReachBottom () {
      // console.log('onReachBottom')
      const { page, size, total } = this.personalPagination
      const maxPage = Math.ceil(total / size)
      if (page + 1 <= maxPage) {
        this.personalPagination.page = page + 1
        this.$nextTick(() => {
          this.personalEndLoading = true
          this.getPersonalData(false, this.personalPagination.page)
        })
      } else {
        // 数据加载完成
        this.personalEndLoading = false
      }
    }
  }
}
</script>

<style lang="less">
.loading-wrapper{
  text-align: center;
  padding-bottom: 25px;
}
.bs-post-wrapper{
  margin-top: 10px;
  max-height: 330px;
  transform: rotate(0deg);
  position: relative;
  overflow: hidden;
}
.loading-end{
  padding: 20px 0;
  text-align: center;
}
.loading-empty{
  width: 100%;
  padding: 20px 0;
}
.rank-item-container{
  -webkit-overflow-scrolling: touch;
}
.personal-list .rank-item-wrapper:last-of-type{
  margin-bottom: 0 !important;
}
.team-week{
  border-top: 1Px solid #E7EAF3;
}
</style>
